(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["quickview-modal"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", (event) => {
        document.querySelector('.quickview-modal-wrapper').addEventListener('click',(e)=>{
            if(e.target.classList.contains('quickview-modal-wrapper')){
                document.querySelector('.quickview-modal-wrapper').classList.remove('active')
            }
        })
        document.querySelector('.quickview-close').addEventListener('click',(e)=>{
            document.querySelector('.quickview-modal-wrapper').classList.remove('active')
        })
        document.addEventListener('click',(e)=>{
            var target = e.target.closest('.quick-view-new')
            if(target){
                var handle = target.getAttribute('data-quickview')
                fetch('/products/'+handle+'?view=quickview')
                .then((response => response.text()))
                .then((response)=>{
                    document.querySelector('.quickview-content').innerHTML = response
                    document.querySelector('.quickview-modal-wrapper').classList.add('active')
                    var selectCallback = function(variant, selector) {
                        console.log(1);
                        var quantity = 1,
                            totalPrice;
                        if (variant) {
                        console.log(2);
                        if (variant.available) {
                            // Selected a valid variant that is available.
                            $('.quickview-modal #AddToCart').removeClass('disabled').removeAttr('disabled').val('Add to Cart').fadeTo(200,1);
                        } else {
                            // Variant is sold out.
                            $('.quickview-modal #AddToCart').val('Sold Out').addClass('disabled').attr('disabled', 'disabled').fadeTo(200,0.5);
                        }
                            quantity = parseInt($('#Quantity').val(), 10);
                            totalPrice = variant.price * quantity;
                            
                            if ( variant.compare_at_price > variant.price ) {
                            $('.quickview-modal .enj-product-price').html('<span class="br-product__price">'+ Shopify.formatMoney(variant.price, window.money_format) + '<del>'+Shopify.formatMoney(variant.compare_at_price, window.money_format)+ '</del>' +'</span>');
                            $('.quickview-modal #ProductPrice').html('<span class="br-product__price engoj_price_main">'+ Shopify.formatMoney(totalPrice, window.money_format) + '</span>');
                            } else {
                            $('.quickview-modal .enj-product-price').html('<span class="br-product__price">'+ Shopify.formatMoney(variant.price, window.money_format) + '</span>');
                            $('.quickview-modal #ProductPrice').html('<span class="br-product__price engoj_price_main">'+ Shopify.formatMoney(totalPrice, window.money_format) + '</span>' );
                            }
                                                    
                        } else {
                        // variant doesn't exist.
                        $('.quickview-modal #AddToCart').val('Unavailable').addClass('disabled').attr('disabled', 'disabled').fadeTo(200,0.5);
                        }
                    }
                    var prod_json = JSON.parse(document.querySelector('.quickview-modal [data-quick-view-json]').innerHTML)
                    jQuery(function($) {
                        new Shopify.OptionSelectors('productSelect-quickview', {
                            product: prod_json,
                            onVariantSelected: selectCallback,
                            enableHistoryState: true
                        });
                    });
                    $('.quickview-modal .slider-for').slick({
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                        asNavFor: '.slider-nav'
                    });
                    $('.quickview-modal .slider-nav').slick({
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        asNavFor: '.slider-for',
                        dots: false,
                        focusOnSelect: true
                    });
                    $('.quickview-modal .zoom').zoom();
                    window.appstleInit()
                })
            }
        })
    })
  } catch(e) { console.error(e); }
})();

})();
